angular.module('sample.widgets.repeatLastSearch', ['adf.provider',
  "ngResource",
  "ivpusic.cookie",
  "EICDataStream3.resources",
  "ui.router",
  'ui.bootstrap.tooltip'])
  .config(['dashboardProvider', function (dashboardProvider) {
    dashboardProvider
      .widget('repeatLastSearch', {
        id: 'repeatLastSearch',
        title: 'Repeat Last Search',
        description: 'Re-run the most recent search you performed',
        controller: 'RepeatLastSearchController',
        //   controllerAs: 'list',
        templateUrl: '/app-ds3/dashboard/widgets/repeatLastSearch/repeatLastSearch.partial.html' //,
        //            edit:         {
        //              templateUrl: '/app/angular-dashboard-framework/widgets/linklist/edit.html',
        //              reload:      false,
        //              controller:  'linklistEditCtrl'
        //            }
      });
  }])
  .controller('RepeatLastSearchController', ['$scope', 'lastSearch', '$state',
    function ($scope, lastSearch, $state) {
      $scope.componentName = "RepeatLastSearchController";

      $scope.getLastSearch = function () {
        $scope.lastSearch = lastSearch.get();
      };

      $scope.repeatLastSearch = function () {
        var newState = "search." + ($scope.lastSearch.searchSubject + ' Summary').toCamelCase();
        if ($scope.lastSearch.searchName) {
          $state.go(newState, { guid: $scope.lastSearch.guid, name: $scope.lastSearch.searchName.urlEncode() });
        }
        else {
          $state.go(newState, { guid: $scope.lastSearch.guid, name: "" });
        }

      };


      $scope.$on('$viewContentLoaded', function () {
        // $scope.getSavedQueries();
        $scope.getLastSearch();
      });
      $scope.$emit('$viewContentLoaded');


    }]);

